import React, { useEffect } from "react";
import { useDisclosure } from "@mantine/hooks";
import {
  Modal,
  Group,
  Button,
  Box,
  Title,
  Text,
  createStyles,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { getConfig } from "../../config";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../../store/types/appState";
import {epicHandler, filterByValueString, getAccessToken, getTokenResponse } from "../../utils";
import { useMedplum } from "@medplum/react";
import { showNotification } from "@mantine/notifications";
import { useDispatch } from "react-redux";

const useStyles = createStyles(() => ({
  title: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  text: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#1C1C1C",
  },
  sunheading: {
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "30px",
    color: "#262930",
  },
  timeButton: {
    height: "30px",
    borderRadius: "4px",
    padding: "6px 14px",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
    color: "black",
  },
  timeBox: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    backgroundColor: "#F9F9F9",
    padding: "24px",
    height: "100%",
    minWidth: "415px",
    maxWidth: "415px",
  },
  boxContinue: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: "16px",
    paddingTop: "32px",
  },
  dateBox: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    backgroundColor: "#F9F9F9",
    padding: "16px",
  },
  dateAndTime: { display: "flex", flexDirection: "column", gap: "16px" },
}));
interface AppointmentProps {
  cancel: any;
  onAppointmentConfirmed: (date: Date, time: string) => void;
}

export interface IAccumulator {
  refreshToken?: string;
  integrationType?: string;
  name?: string;
}

export const AppointmentModal: React.FC<AppointmentProps> = ({
  cancel,
  onAppointmentConfirmed,
}) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [opened, { open, close }] = useDisclosure(false);
  const [value, setValue] = useState<Date | null>(null);
  const currentDate = new Date();
  const medplum = useMedplum()
  const maxDate = new Date(currentDate);
  maxDate.setFullYear(currentDate.getFullYear() + 1);

  //apii integrations------------------
  // const [responseData, setResponseData] = useState<any>(null);
  const [dateandTime, setdateandTime] = useState<any>([]);
  const [availabelTime, setAvailabelTime] = useState<any>([]);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const [resources, setresources] = useState<any>([]);
  const logginedUser = useSelector((state: AppState) => state) as any;
  const statuss: any[] = logginedUser?.app?.profile?.extension || [];
  const epicObject = statuss.find((item) =>
    item.extension.some(
      (ext: any) => ext.url === "integrationType" && ext.valueString === "epic"
    )
  );


  // Extract the access token from the epic object
  const accessToken = epicObject
    ? epicObject.extension.find((ext: any) => ext.url === "access_token")
        ?.valueString
    : null;
  const config = getConfig();

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const activeLogin = getAccessToken();
      const epicDataFromExtension = filterByValueString(
        logginedUser?.app?.profile?.extension || ([] as any),
        "epic"
      );

      if (!epicDataFromExtension.length) {
        showNotification({
          color: "red",
          message: "Please connect EPIC client!",
          autoClose: true,
        });
        cancel();
        return;
      }

      const fetchAppointments = async (
        retry: boolean = false
      ): Promise<void> => {
        try {
          const result: IAccumulator = epicDataFromExtension[
            epicDataFromExtension.length - 1
          ]?.extension?.reduce((acc: IAccumulator, { url, valueString }) => {
            if (url === "refresh_token") {
              acc.refreshToken = valueString;
            } else if (url === "integrationType") {
              acc.integrationType = valueString;
            } else if (url === "display") {
              acc.name = valueString;
            }
            return acc;
          }, {});

          const clientId =
            epicDataFromExtension[epicDataFromExtension.length - 1]?.url?.split(
              "/"
            )?.[1];

          let tokenData: any;
          // if (result.integrationType && result.refreshToken) {
          //   tokenData = await getTokenResponse(
          //     medplum,
          //     dispatch,
          //     clientId,
          //     result.integrationType,
          //     result.refreshToken,
          //     activeLogin
          //   );
          // }

          const findAppointmentPayload = {
            eventType: "findAppointment",
            accessToken:
              epicDataFromExtension[epicDataFromExtension.length - 1]
                ?.extension?.[0]?.valueString || "",
          };

          const metaData = {
            dispatch,
            clientId: clientId,
            integrationType: result.integrationType,
            refreshToken: result.refreshToken,
            activeLogin,
            name: result.name
          }

          const response = await epicHandler(medplum, findAppointmentPayload, metaData);
          //  tokenData = await getTokenResponse(
          //    medplum,
          //    dispatch,
          //    clientId,
          //    result.integrationType,
          //    result.refreshToken,
          //    activeLogin,
          //    result.name??'provider name'
          //  );

          // if (response.status === 401 && !retry) {
          
          //   if (result.integrationType && result.refreshToken) {
          //     tokenData = await getTokenResponse(
          //       medplum,
          //       dispatch,
          //       clientId,
          //       result.integrationType,
          //       result.refreshToken,
          //       activeLogin,
          //       result.name??'provider name'
          //     );
          //     // Retry fetchAppointments once with the new token
          //     if (tokenData.message.includes("Failed to refresh token")) {
          //         showNotification({
          //           color: "red",
          //           message: "Token expired! Please connect EPIC client again.",
          //           autoClose: true,
          //         });
          //       return;
          //     }
          //       await fetchAppointments(true);

          //     return
             
          //   }
          // }

          if (response.status !== 200) {
            throw new Error("Failed to fetch data");
          }

          const responseData = response.body;
          responseData.entry.map((entry: any) => {
            setresources(responseData);
          });

          const startEndData = responseData?.entry?.map((entry: any) => ({
            start: entry?.resource?.start,
            end: entry?.resource?.end,
          }));

          // Output the results
          const formattedData = startEndData.map((item: any) => {
            if (item.start && item.end) {
              const startDateArr = item.start.split("T");
              const endDateArr = item.end.split("T");

              const startDate = {
                date: startDateArr[0],
                time: startDateArr[1].slice(0, 5),
              };

              const endDate = {
                date: endDateArr[0],
                time: endDateArr[1].slice(0, 5),
              };

              return {
                start: startDate,
                end: endDate,
              };
            } else {
              return item;
            }
          });

          const times = formattedData
            .filter(
              (entry: any) =>
                entry.start &&
                entry.start.date === value &&
                entry.end &&
                entry.end.date === value
            )
            .map((entry: any) => ({
              startTime: entry.start.time,
              endTime: entry.end.time,
            }));

          setdateandTime(formattedData);
        } catch (error) {
          console.error(error);
        }
      };

      await fetchAppointments();
    };

    fetchData();

    return () => {};

  }, []);

  const navigate = useNavigate();
  const handleTimeSelection = (time: any) => {
    setSelectedTime(time);
    const Time = JSON.stringify(selectedTime);
    localStorage.setItem("time", Time);

    if (resources && resources.entry) {
      const selectedTimeRange = time;
      const [selectedStartTime, selectedEndTime] = selectedTimeRange.split("-");

      // Function to check if a time falls within a range
      const isTimeInRange = (
        time: string,
        startTime: string,
        endTime: string
      ) => {
        return time >= startTime && time <= endTime;
      };

      // Filter appointments based on selected time
      const filteredAppointments = resources?.entry.filter((entry: any) => {
        const start = entry?.resource?.start?.split("T")[1].slice(0, 5); // Extracting time part
        const end = entry?.resource?.end?.split("T")[1].slice(0, 5); // Extracting time part
        return (
          isTimeInRange(start, selectedStartTime, selectedEndTime) &&
          isTimeInRange(end, selectedStartTime, selectedEndTime)
        );
      });

      // Log filtered appointments
      if (filteredAppointments.length > 0) {
        const appointmentResource = filteredAppointments[0].resource.id;
        localStorage.setItem(
          "appointmentResource",
          JSON.stringify(appointmentResource)
        );
      }
    }
  };

  const handleDateChange = (newDate: any) => {
    if (newDate instanceof Date) {
      const adjustedDate = new Date(
        newDate.getTime() - newDate.getTimezoneOffset() * 60000
      );
      const convertedDate = adjustedDate.toISOString().split("T")[0];
      setValue(adjustedDate);
      const SelectedDate = JSON.stringify(value);
      localStorage.setItem("date", SelectedDate);

      const availableTimesForSelectedDate = dateandTime
        .filter(
          (entry: any) =>
            entry.start &&
            entry.start.date === convertedDate &&
            entry.end &&
            entry.end.date === convertedDate
        )
        .map((entry: any) => `${entry.start.time}-${entry.end.time}`);

      setAvailabelTime(availableTimesForSelectedDate);
    }
  };
  const HandleContinue = () => {
    // const Date = JSON.stringify(value);
    // const Time = JSON.stringify(selectedTime);
    // localStorage.setItem("date", Date);
    // localStorage.setItem("time", Time);
    if (value && selectedTime) {
      // Invoke the callback function with selected date and time
      onAppointmentConfirmed(value, selectedTime);
    }
  };

  const renderTimeButtons = (availableTimes: any[], selectedDate: string) => {
    if (availableTimes.length === 0) {
      return <Text>No slots available please select another date</Text>;
    }
  
    return (
      <Box
        sx={{
          display: "flex",
          gap: "24px",
          flexWrap: 'wrap',
        }}
      >
        {availableTimes.map((time: any, index: number) => (
          <Button
            key={index}
            className={classes.timeButton}
            variant={selectedTime === time ? "filled" : "outline"}
            onClick={() => handleTimeSelection(time)}
          >
            {time}
          </Button>
        ))}
      </Box>
    );
  };

  function formatDate(inputDateString: string): string {
      const inputDate: Date = new Date(inputDateString);

      const year: number = inputDate.getFullYear();
      const month: number = inputDate.getMonth() + 1;
      const day: number = inputDate.getDate();

      const formattedDateString: string = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
      
      return formattedDateString;
  }


  interface DateTimeEntry {
    start?: { date: string; time: string };
    end?: { date: string; time: string };
  }

  function checkIfDateExists(inputDate: Date, dateTimeArray: DateTimeEntry[]): boolean {
    const inputDateString: string = inputDate?.toDateString();

    const formattedDate: string = formatDate(inputDateString);

    for (const dateTimeEntry of dateTimeArray) {
        if (dateTimeEntry.start && dateTimeEntry.start.date === formattedDate) {
            return false; // Date exists, return false
        }
        if (dateTimeEntry.end && dateTimeEntry.end.date === formattedDate) {
            return false; // Date exists, return false
        }
    }

    // If no matching date found, return true
    return true;
  }

  return (
    <>
      <Box>
        <Box className={classes.dateAndTime}>
          <Title className={classes.title}>Date and time</Title>
          <Text className={classes.text}>
            Please choose a date and time to schedule your appointment. Your
            selection is essential for securing a convenient slot.
          </Text>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "24px",
            paddingTop: "32px",
          }}
        >
          <Box className={classes.dateBox}>
            <Title className={classes.sunheading}>Date</Title>
            <Group position="center">
              <DatePicker
                value={value}
                onChange={handleDateChange}
                defaultDate={currentDate}
                minDate={new Date()}
                maxDate={maxDate}
                size="xl"
                hideOutsideDates
                monthsListFormat="MM"
                yearsListFormat="YY"
                excludeDate={(date) =>  date && checkIfDateExists(date, dateandTime)}
              />
            </Group>
          </Box>
          <Box>
            <Box className={classes.timeBox}>
              <Title className={classes.sunheading}>Time</Title>
              <Box
                sx={{
                  display: "flex",
                  gap: "24px",
                  flexWrap: "wrap",
                }}
              >
                {renderTimeButtons(
                  availabelTime,
                  value ? value.toISOString().split("T")[0] : ""
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className={classes.boxContinue}>
          <Button variant="outline" onClick={cancel}>
            Cancel
          </Button>
          <Button variant="filled" onClick={HandleContinue} disabled={!selectedTime}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default AppointmentModal;
